<div class="flex items-center justify-between">
  <div class="flex items-center">
    <mat-icon svgIcon="view_timeline" class="mr-8"></mat-icon>
    <div class="mat-subtitle-2 mb-0 fs-24 fw-600">{{'INSTANCE_DETAILS.ACTIVITY' | transloco}} 
      <span>({{searchTerm?.length > 0 && searchedResult ? searchedResult.length || 0 : (deploymentLogData?.length || 0)}})</span>
    </div>
    <div class="ml-16 search-activity mt--24">
      <app-search-filter [ngClass]="{'disabled': showActivityLoader}" class="mt-20 ml-20" placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
    </div>
    <span class="vertical-dash ml-12"></span>
    <button [ngClass]="{'disabled': showActivityLoader || !deploymentLogData?.length}" class="flex justify-center items-center context-menu-icon-filter height menu-btn pr-8 pl-8 pt-6 pb-6 ml-16 filter"
      (click)="dateFilter()">
      <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
      <span class="fw-500 filters">{{'INSTANCE_DETAILS.FILTER' | transloco}}</span>
    </button>
  </div>
  <div class="flex flex-row gap-3 create-runbook">
    <div class="refresh-circle rounded-full w-32 h-32 flex items-center justify-center cursor-pointer" (click)="refreshClick()">
      <mat-icon svgIcon="refresh" class="icons transition-transform duration-700" [ngClass]="{ 'animate-spin': showActivityLoader && deploymentLogData }"></mat-icon>
    </div> 
    <app-environment-paginator class="envt-paginator" [length]="searchedResult?.length" [pageIndex]="pageIndex" [pageSize]="paginationSize" (page)="onPageChange($event)"></app-environment-paginator>
  </div>
</div>
<div class="flex flex-row items-center ml-8 pt-8">
  <div class="flex flex-row items-center">
    @if(selectedActions?.length > 0){<div
      class="mr-4 flex items-center fs-16 fw-500 mt-8">
      <span class="pr-8 fs-16">{{ 'TOOLBAR.ACTION' | transloco }}</span>
      <div *ngFor="let option of selectedActions; let i = index" class="flex items-center date-tag pt-4 pb-4 pl-12 pr-8 mr-8">
        <span>{{option | titlecase}}</span>
        <span class="ml-8"><mat-icon svgIcon="close" class="cursor-pointer icon-sm pl-2"
          (click)="cancelActionFilter(option)"></mat-icon></span>
      </div>
    </div>
    }
    @if(filterStartDate && filterEndDate) {
      <div class="flex items-center">
        <span class="pr-8 fs-16 mt-8">{{ 'TOOLBAR.DATE' | transloco }}</span>
        <div class="mr-4 pt-4 pb-4 pl-12 pr-8 date-tag flex items-center fs-16 fw-500 mt-8">{{
          datePipe.transform(filterStartDate, 'dd MMM yyyy') }} - {{
          datePipe.transform(filterEndDate, 'dd MMM yyyy') }}
          <span class="ml-8"><mat-icon svgIcon="close" class="cursor-pointer icon-sm"
              (click)="cancelFilter()"></mat-icon></span>
        </div>
      </div>
    }
     @if(selectedActions?.length > 0 || (filterStartDate && filterEndDate)) {
      <span class="fs-16 fw-500 cursor-pointer warn-solid-fg mt-8 ml-8" 
        (click)="clearAllFilters()">
        {{ 'BUTTONS.CLEAR_ALL' | transloco }}
      </span>
    }
  </div>
</div>

<div class="flex flex-col mt-16 details-container">
  <mat-divider class="title-divider"></mat-divider>
  <div class="flex flex-col endpoints deploymentLogs envt-activity" [ngClass]="{'disabled': showLoader}">
  <app-environment-table class="mt-20" [initialDataSource]="deploymentLogData" [displayColumns]="displayColumns" [innerTableColumns]="innerTableColumns" [dataLoading]="showActivityLoader" (searchedResults)="searchedItems($event)" [searchTerm]="searchTerm" [showSkeletonLoader]="true" page="activity" [dataSourceLength]="true" pageName="activity" (sorted)="resetPaginator()" (pageModify)="onTablePageChanged($event)" (pageChanged)="onPageChange($event)" (arrowClicked)="onArrowClick($event)" (rowClicked)="onRowClick($event)" (thresholdClick)="thresholdDetails($event)"></app-environment-table>  </div>
</div>